import React, { memo } from "react";
import PrintablePedido from "../../../components/PrintablePedido/PrintablePedido";
import { LayoutImpressaoPedido } from "../../../types/LayoutImpressao";
import "./styles";
import PedidosImpressaoContainer from "./styles";

interface PedidosImpressaoProps {
  pedidos: any;
  layoutConfig?: LayoutImpressaoPedido;
}

const PedidosImpressao: React.ForwardRefRenderFunction<
  HTMLDivElement,
  PedidosImpressaoProps
> = ({ pedidos, layoutConfig }, ref) => {
  return (
    <PedidosImpressaoContainer ref={ref}>
      {pedidos.map((pedido, index) => (
        <PrintablePedido
          key={index}
          pedido={pedido}
          informacoesPagamento={pedido.informacoesPagamento}
          layoutConfig={layoutConfig}
          observacoes={pedido.observacoesPedido || []}
        />
      ))}
    </PedidosImpressaoContainer>
  );
};

export default memo(React.forwardRef(PedidosImpressao));
